<template>
  <transition name="fade" mode="out-in">
  <div class="navbar-links" v-if="show">
      <div class="navbar-link-container"
           v-for="(link, key) in navLanguageLinks"
           :key="key"
      >
        <router-link
            class="navbar-link"
            :to="link.to"
        >
          {{ link.text }}
        </router-link>
      </div>
  </div>
  </transition>
</template>

<script>
import {mapGetters, mapState} from "vuex";

export default {
  name: "NavbarLinks",
  computed: {
    ...mapState([
        "show"
    ]),
    ...mapGetters([
        "navLanguageLinks"
    ])
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/variables";

.navbar-links {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.navbar-link {
  font-size: $router-element-size;
  &-container {
    margin-left: 20px;
  }
}
</style>